import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";

import { Skeleton } from "@mui/material";

import {
  cartApi,
  salesPackagesApi,
  walletBalanceApi,
} from "../../../utility/api/apiList";

import { showDangerAlert } from "../../../redux/actions/alert/alertActions";

import useAxios from "../../../hooks/useAxios";
import scrollToTop from "../../../libs/scrollToTop";

import PersonalPurchaseSkeleton from "../personalPurchase/personalPurchaseSkeleton";
import PersonalAndGroupPayment from "../../../components/public/purchase/payment";
import LayoutPurchaseComponent from "../../../components/public/purchase/layoutPurchase";
import ButtonComponent from "../../../components/public/button";

import { Wrapper, PurchaseInformation, StyledWalletData } from "./styledPaymentPage";
import {
  PaymentInformationSkeleton,
  WalletBalanceSkeleton,
} from "./paymentSkeleton";


const PaymentPageContainer = () => {
  const [unitOfTime, setUnitOfTime] = useState(true);

  const location = useLocation();
  const dispatch = useDispatch();

  //useAxios
  const {
    data: walletBalanceData,
    isLoading: walletBalanceLoading,
    run: walletBalanceRun,
  } = useAxios({
    url: walletBalanceApi,
  });

  const {
    data: salesPackageData,
    isLoading: isSalesPackageLoading,
    run: salesPackageRun,
  } = useAxios({
    url: salesPackagesApi,
    params: {
      page_size: 100,
    },
  });

  const {
    data: cartData,
    isLoading: isCartDataLoading,
    run: getCartDataRun,
  } = useAxios({
    url: cartApi,
  });

  useEffect(() => {
    scrollToTop();
    document.title = "پرداخت";

    walletBalanceRun();
    salesPackageRun();

    getCartDataRun()
      .then((response) => {
        if (!response.data.data[0].unitoftime.id) {
          setUnitOfTime(false);
        }
      })
      .catch((err) => {
        dispatch(showDangerAlert(err.response.data.details));
      });
  }, []);

  const PaymentSkeleton = () => {
    return (
      <LayoutPurchaseComponent
        show={false}
        cardTitle={unitOfTime ? "اشتراک گروهی" : "اشتراک شخصی"}
        rowClassName="w-100 flex-grow-1"
        $height="auto"
      >
        <Wrapper className="p-0 mt-2 mt-md-4 mx-auto">
          {!unitOfTime && (
            <span className="p-0">
              <PersonalPurchaseSkeleton className="mt-md-5" />
            </span>
          )}
          <span className="p-0">
            <PurchaseInformation className="p-0 pt-4 pb-4 d-flex flex-column justify-content-center align-items-center">
              <PaymentInformationSkeleton />
            </PurchaseInformation>
            <StyledWalletData className="mx-auto my-3 py-3 px-1 px-sm-3 d-flex justify-content-center justify-content-lg-between align-items-center">
              <span className="p-0 w-auto d-flex justify-content-center align-items-center">
                <Skeleton height={50} width={200} />
              </span>
              <WalletBalanceSkeleton />
            </StyledWalletData>
            <ButtonComponent
              className="submit-payment-button w-100 mb-4 mb-md-2"
              disabled={true}
            >
              پرداخت
            </ButtonComponent>
          </span>
        </Wrapper>
      </LayoutPurchaseComponent>
    );
  };

  let element = null;
  if (isCartDataLoading || walletBalanceLoading || isSalesPackageLoading) {
    element = <PaymentSkeleton />;
  } else {
    element = (
      <PersonalAndGroupPayment
        cartResponse={cartData}
        walletResponse={walletBalanceData}
        salesPackageResponse={salesPackageData}
        unitOfTime={unitOfTime}
        simID={location?.simID}
      />
    );
  }
  return element;
};

export default PaymentPageContainer;
